import React from 'react'
import { Form } from 'semantic-ui-react'

export default class PhoneField extends React.PureComponent {
  render() {
    const { value, onChange, required } = this.props

    return (
      <Form.Input
        fluid
        label="Phone"
        required={required}
        placeholder="e.g +855 xx xxx xxx"
        onChange={e => onChange('phone', e.target.value)}
        value={value}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/restaurants/fields/phoneField.js